module.exports = __webpack_public_path__ + "img/close-icon.a0559092.svg";